import PaneSwitchOffIcon from "app/components/Icons/PaneSwitchOffIcon";
import { selectIsCollapseSidebarMenu } from "app/redux/selector";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../components/Layout";
import { selectDraftBoardForm } from "../../components/Settings/redux/selector";
import { selectSelectedTickets } from "../../redux/selector";
import { ListView } from "../Tickets/components/ListView";
import Loading from "../Tickets/containers/List/Loading";
import {
  selectGroupingLoader,
  selectTicketCache,
  selectTicketGroups,
} from "../Tickets/redux/selector";
import Planning from "./components/Planning";
import { filterTicketGroupsByTicketIds } from "./helper";
import {
  selectPlanningFilterLoading,
  selectSelectedPlanningTile,
} from "./redux/selector";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import SprintSaga from "app/containers/Features/containers/Sprints/redux/saga";
import {
  reducer as sprintReducer,
  sliceKey as sprintSliceKey,
} from "app/containers/Features/containers/Sprints/redux/slice";
import SprintDetailsSaga from "app/containers/Features/containers/Sprints/SprintDetails/redux/saga";
import {
  sprintDetailsReducer,
  sprintDetailsSliceKey,
} from "app/containers/Features/containers/Sprints/SprintDetails/redux/slice";
import { backlogKey, backlogReducer } from "./redux/slice";
import { backlogSaga } from "./redux/saga";

export default function Backlog() {
  useInjectReducer({ key: sprintSliceKey, reducer: sprintReducer });
  useInjectSaga({ key: sprintSliceKey, saga: SprintSaga });
  useInjectReducer({
    key: sprintDetailsSliceKey,
    reducer: sprintDetailsReducer,
  });
  useInjectSaga({ key: sprintDetailsSliceKey, saga: SprintDetailsSaga });
  useInjectReducer({ key: backlogKey, reducer: backlogReducer });
  useInjectSaga({ key: backlogKey, saga: backlogSaga });

  const selectedTickets = useSelector(selectSelectedTickets);
  const [showPlanning, setShowPlanning] = useState(false);
  const groups = useSelector(selectTicketGroups);
  const ticketCache = useSelector(selectTicketCache);
  const selectedPlanningTile = useSelector(selectSelectedPlanningTile);
  const isPlanningFilterLoading = useSelector(selectPlanningFilterLoading);
  const boardData = useSelector(selectDraftBoardForm);
  const isLoading = useSelector(selectGroupingLoader);
  const isSidebarOpen = useSelector(selectIsCollapseSidebarMenu);

  const filteredGroups = useMemo(() => {
    if (!selectedPlanningTile) return groups;

    return filterTicketGroupsByTicketIds(
      groups,
      selectedPlanningTile.ticketIds,
      ticketCache,
    );
  }, [groups, selectedPlanningTile, ticketCache]);

  const renderContent = () => {
    return (
      <div className="w-full max-h-[calc(100vh-160px)] overflow-y-auto overflow-x-auto">
        <div
          className={`min-w-0 w-full ${
            isSidebarOpen
              ? "max-w-[calc(100vw-258px-360px)]"
              : "max-w-[calc(100vw-54px)]"
          }`}
        >
          <ListView
            groups={filteredGroups}
            boardData={boardData}
            selectedTickets={selectedTickets}
          />
        </div>
      </div>
    );
  };
  return (
    <>
      <Layout>
        <div className="flex gap-[16px] pe-[24px] w-full min-w-0">
          <div className="flex-1 min-w-0 overflow-y-auto overflow-x-auto pr-[8px] space-y-[16px]">
            <div className="flex gap-[16px] h-[calc(100vh-160px)]">
              <div className="w-full min-w-0">
                {isLoading || isPlanningFilterLoading ? (
                  <Loading />
                ) : (
                  renderContent()
                )}
              </div>
            </div>
          </div>
          {!showPlanning && (
            <button
              className="size-[20px] mt-[3px] flex-shrink-0"
              onClick={() => setShowPlanning(true)}
            >
              <PaneSwitchOffIcon />
            </button>
          )}
          {showPlanning && <Planning onClose={() => setShowPlanning(false)} />}
        </div>
      </Layout>
    </>
  );
}
